<template>
  <div id="completed-flip-grid">
    <v-toolbar
      flat
    >
      <v-toolbar-title class="text-h5 pa-0">Completed/Sold</v-toolbar-title>
    </v-toolbar>
    <v-row v-if="flipCompletedAssetList">
      <v-col
        v-for="(asset, a) in flipCompletedAssetList.entries"
        :key="a"
        cols="12"
        md="3"
        sm="6"
        class="align-self-stretch"
      >
        <CarCard :asset="asset"></CarCard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import CarCard from '../components/CarCard.vue'
  import {mapGetters, mapActions } from 'vuex'

  export default {
    name: 'CompletedFlipGrid',

    components: {
      CarCard
    },

    computed: {
      ...mapGetters(['flipCompletedAssetList'])
    },

    data: () => ({
    }),

    methods: {
      ...mapActions(['getCompletedFlipAssets']),
    },

    created() {
      this.getCompletedFlipAssets()
    }
  }
</script>
